import React from 'react';
import { FooterLink } from './FooterLink';
import { useLocalizedPaths } from '../../hooks/useLocalizedPaths';

export const FooterLinksList = ({ links }) => {
  const { getLocalizedPath } = useLocalizedPaths();

  return (
    <ul className="space-y-2">
      {links.map(({ to, labelKey, external }) => (
        <li key={to}>
          <FooterLink 
            to={external ? to : getLocalizedPath(to)}
            external={external}
          >
            {labelKey}
          </FooterLink>
        </li>
      ))}
    </ul>
  );
};